import { BaseContactDialog } from '@certara/common-react-components';
import { useUIStore } from '@/stores/ui-store';

export function ContactDialog() {
  const open = useUIStore((state) => state.contactDialogOpen);
  const setOpen = useUIStore((state) => state.setContactDialogOpen);

  return <BaseContactDialog open={open} onClose={() => setOpen(false)} />;
}
